module.exports = __webpack_public_path__ + "img/20250702.1554b8e9.jpg";